<template>
	<div class='lpo-geometry-data'>
	
		<div class='wrapper'>

			<!-- <DataBlock title='Границы и площадь выдела'> -->
				<InspectionGeometry/>
			<!-- </DataBlock> -->

			<div class='links-block'>
				<router-link :to='linkPrev'><- Назад - Участок</router-link>
				<router-link class='right' :to='linkNext'>Далее - Данные обследования -></router-link>
			</div>

		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	// import DataBlock from './DataBlock';

	import InspectionGeometry from './CurrentLpoGeometry__main';



	export default {
		name: 'SelectedLpoTabGeometry',

		components: {
			// DataBlock,
			InspectionGeometry,
		},

		computed: {
			linkPrev() { return { name: 'current-lpo-section' }; },
			linkNext() { return { name: 'current-lpo-inspection' }; },

			...mapGetters('selectedLpo', [
				'lpoAddress',
			])
		},

	};
</script>

<style scoped src='@/style/wrapper.css'></style>

<style scoped>
	.data-block {
		margin-bottom: 5rem;
	}

	.right {
		float: right;
	}
</style>